var generateStyle = function generateStyle(componentTheme) {
  return {
    createButton: {
      marginTop: componentTheme.createButtonMargin
    },
    hint: {
      margin: "".concat(componentTheme.hintMargin, " 0")
    },
    createBlankText: {
      fontWeight: componentTheme.createBlankTextWeight
    },
    createBlankHotkeyText: {
      fontWeight: componentTheme.createBlankHotkeyTextWeight,
      fontSize: componentTheme.createBlankHotkeyTextSize,
      paddingSeft: componentTheme.createBlankHotkeyTextPadding
    }
  };
};
export default generateStyle;